import React from 'react';
import clsx from 'clsx';
import {
    Checkbox
  } from  "@material-ui/core";

const CheckActions = (props) => {

    const{
        label,
        enableActions,
        setEnableActions,
        clearAll
    }=props;



    return(
        <div className={clsx('flexRowDirection')}  style={{justifyContent: 'space-between'}}>
            <div className={clsx('flexRowDirection','teamSelector')} aria-hidden="true" onClick ={() => setEnableActions(!enableActions)}>
                <Checkbox checked={enableActions} style={{color: '#0c4d82'}} onChange={() => setEnableActions(!enableActions)} inputProps={{ 'aria-label': 'uncontrolled-checkbox' }} />
                <span className={clsx('boldBlue')}>&nbsp;{label}</span>
            </div>
            { enableActions === true &&
                <span className={clsx('clearAllStyle', 'teamSelector')} aria-hidden="true" onClick ={ () => clearAll()}> Clear all</span>
            }
        </div>
    )

}

export default CheckActions;